import { BrandingTheme } from '@torticity/types'

import { Theme } from './theme'

const config: Theme = {
  key: BrandingTheme.AMBER,
  label: 'amber',
  tokens: {
    'primary-button': [
      'tw-bg-amber-600',
      'hover:tw-bg-amber-900',
      'tw-text-white',
      'tw-py-4',
      'tw-px-6',
      'tw-rounded-full',
      'tw-font-bold',
      'tw-text-md',
      'tw-cursor-pointer',
      'disabled:tw-opacity-50',
      'disabled:tw-cursor-not-allowed',
    ],
    'secondary-button': [
      'tw-border-amber-200',
      'tw-bg-amber-100',
      'tw-text-amber-950',
      'hover:tw-bg-amber-300',
      'active:tw-bg-amber-400',
      'tw-cursor-pointer',
    ],
    'tertiary-button': [
      'tw-bg-white',
      'tw-border-2',
      'tw-border-amber-600',
      'tw-text-amber-900',
      'hover:tw-bg-amber-50',
      'active:tw-bg-amber-100',
      'tw-rounded-full',
      'tw-font-semibold',
      'tw-text-md',
      'tw-py-2',
      'tw-px-6',
      'tw-cursor-pointer',
    ],
    'primary-text': ['tw-text-amber-700'],
    'header-nav': ['!tw-bg-amber-900'],
    'header-active-item': [
      'tw-font-semibold',
      'tw-text-amber-800',
      'tw-bg-white',
      'tw-bg-opacity-80',
    ],
    'loading-spinner': ['tw-fill-amber-600'],
    'primary-icon': ['tw-fill-amber-500', 'tw-text-amber-500'],
    'secondary-icon': [
      'tw-text-amber-800',
      'tw-bg-amber-100',
      'tw-flex',
      'tw-flex-shrink-0',
      'tw-content-center',
      'tw-items-center',
      'tw-justify-center',
      'tw-rounded-full',
    ],
    'tertiary-icon': ['tw-fill-amber-800', 'tw-text-amber-700'],
    'auth-footer': ['tw-text-white', '!tw-bg-amber-800'],
    'secondary-text': ['tw-text-amber-500'],
    'linear-gradient': ['tw-to-amber-500', 'tw-from-amber-900'],
    'light-linear-gradient': ['tw-bg-amber-500'],
    'dark-linear-gradient': ['tw-bg-amber-900'],
    'light-background': ['tw-bg-amber-50'],
    'dark-background': ['tw-bg-amber-700'],
    'tracker-dots': ['tw-border-amber-500', 'tw-bg-amber-50'],
    'active-tracker-dot': ['tw-bg-amber-800', 'tw-rounded-full'],
    'action-flow': ['tw-bg-amber-600'],
    'action-flow-button': ['tw-bg-amber-600', 'hover:tw-bg-amber-900'],
    'mobile-tracker-line': ['tw-bg-amber-500'],
    'bottom-nav-active-bar': ['tw-bg-amber-700'],
    'primary-border': ['tw-border-amber-500'],
    'dark-border': ['tw-border-amber-700'],
    'hover-background': ['hover:tw-bg-amber-50'],
    'hover-border': ['hover:tw-border-amber-500'],
    'important-badge': ['tw-bg-amber-100', 'tw-text-amber-950'],
  },
}

export default config
